<template>
  <div class="container">
    <div class="flex wrap">
      <state
      class="sub-container"
      :statedata="$store.state"
      parent="state"
    />
      <if :item="state" :data="{state: state.if, name:'mark'}"/>
      <button @click="$store.dispatch('if', state.conditions)">Run IF Test</button>
      <div class="flexz flex column fit" style="overflow: scroll">
        <div class="flex column sub-container">
          <b>External API:</b>
          <div>
            <span
              :style="externalApi.verb === verb ? 'font-weight: 900;' : ''"
              class="xs-font p4"
              @click="
                externalApi.verb = verb;
                test = 'axios.' + externalApi.verb;
              "
              v-for="(verb, verbKey) in verbs"
              :key="verbKey"
              :value="verb"
              >{{ verb }}</span
            >
          </div>
          <input
            class="xs-input xsy-font b8"
            type="text"
            v-model="externalApi.address"
            placeholder="API Endpoint"
          />
          <b class="sm-font">Examples:</b>
          <code
            @click="
              method = false;
              data = '{}';
              test = 'axios.' + externalApi.verb;
            "
            class="xs-font flex column"
          >
            <a
              v-for="(example, exampleKey) in examples"
              :key="exampleKey"
              class="indicate-text"
              @click.prevent="
                externalApi.address = example;
                externalApi.verb = 'get';
              "
              >-> {{ example }}</a
            >
          </code>
        </div>
        <!-- <div class="sub-container">
          <b>Mutations: </b>
          <div class="flex wrap align-center p8">
            <a
              @click.prevent="
                externalApi.address = '';
                jsond = true;
                method = 'mutation';
                test = mutationKey;
                data = mutation;
              "
              class="l4 r8 update-text"
              v-for="(mutation, mutationKey) in $store.state.vuex.mutations"
              :key="mutationKey"
              >{{ mutationKey }}( )</a
            >
          </div>
        </div>
        <div class="sub-container">
          <b>Actions: </b>
          <div>
            <div
              class="l4 r4"
              v-for="(action, actionKey) in $store.state.vuex.actions"
              :key="actionKey"
            >
              <i class="label">{{ actionKey }}</i>
              <div class="flex wrap p8">
                <a
                  @click.prevent="
                    externalApi.address = '';
                    jsond = true;
                    method = 'action';
                    test = actionKey;
                    data = type;
                    data.type = typeKey;
                  "
                  v-for="(type, typeKey) in action"
                  :key="typeKey"
                  class="r8 success-text"
                  >{{ typeKey }}( )</a
                >
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <div
        v-if="method || externalApi.address"
        class="flex column sub-container flexx"
        style="max-width: 480px; overflow: scroll"
      >
        <b>{{ test || "axios." + externalApi.verb }}( )</b>
        <code class="xs-font">{{ externalApi.address }}</code>
        <label
          v-if="!returnVal"
          for="test-data"
          class="flex container column fill b8"
        >
          <code
            v-if="jsond && !externalApi.address"
            @click="
              jsond = false;
              data = JSON.stringify(data, null, 2);
            "
            >{{ data }}</code
          >
          <textarea
            class="sm-font fill"
            style="min-height: 40vh"
            v-if="!jsond || externalApi.address"
            id="test-data"
            v-model="data"
            placeholder="Valid JSON string"
          ></textarea>
        </label>
        {{method}}
        <button
          v-if="!returnVal"
          :class="
            method === 'action'
              ? 'success p8'
              : method === 'mutation'
              ? 'update p8'
              : 'indicate p8'
          "
          @click="
            !jsond ? ((data = JSON.parse(data)), (jsond = true)) : null;
            method === 'action'
              ? testAction()
              : method === 'mutation'
              ? testMutation()
              : testMethod();
          "
          type="button"
        >
          {{
            method === "action"
              ? "Dispatch"
              : method === "mutation"
              ? "Commit"
              : "Hit Endpoint"
          }}
        </button>
        <div
          v-if="returnVal"
          style="overflow: scroll"
          class="fill-h container p4"
        >
          <div class="flex between wrap align-center">
            <button
              @click="returnVal = false"
              class="warn sm-font"
              type="button"
            >
              <i class="fas fa-trash r4"></i> Clear Data
            </button>
            <b>Output: </b>
            <button
              v-if="!save"
              @click="save = true"
              class="update sm-font"
              type="button"
            >
              <i class="fas fa-save r4"></i> Save Data
            </button>
            <button
              v-if="save"
              @click="save = false"
              class="update sm-font"
              type="button"
            >
              <i class="fas fa-times r4"></i> Cancel Save Mode
            </button>
            <div v-if="save" class="flex wrap around xs-font">
              <input
                v-model="variable.datatype"
                class="sm-input"
                type="text"
                placeholder="Type / Folder"
              />
              <input
                v-model="variable.key"
                class="sm-input"
                type="text"
                placeholder="Key / Variable"
              />
              <button
                @click="
                  $store.dispatch('create', {
                    type: 'value',
                    datatype: variable.datatype,
                    key: variable.key,
                    value: JSON.stringify(returnVal),
                  })
                "
                type="button"
              >
                Assign
              </button>
            </div>
          </div>
          <div>{{ returnVal }}</div>
        </div>
      </div>
    </div>
    <button type="button" @click="decode()">Dec0de</button>
    <!-- <itable :tdata="$store.state.items ? $store.state.items : {}" /> -->
    <!-- <component v-for="comp in ['x', 'y', 'wallet', 'idisplay']" :key="comp" :is="comp" /> -->
    <!-- <istate class="container" :statedata="$store.state" count="1" /> -->
    <!-- payload: ['type', 'database id', 'itemid', 'function'] -->
    <button
      @click="
        $store
          .dispatch('schedule', {
            type: 'event',
            command: 'set',
            appid: $store.state.app.basics.database,
            itemid: 'tests',
            function: { illrun: 'oneday' },
            validations: { sign: 'mark' },
            time: 2030431875227,
          })
          .then((e) => e)
      "
    >
      Schedule function
    </button>
    <button
      @click="
        $store.dispatch('ipfs', { whatup: 'mars' }).then((d) => {
          $set(inputs, 'ipfs', d.path);
        })
      "
    >
      IPFS TEST
    </button>

    <h2>Shared Secrets test</h2>
    <input
      placeholder="number of splits"
      v-model.number="inputs.secretshares"
    />
    <input
      placeholder="required shares to recombine"
      v-model.number="inputs.secretthresh"
    />
    <textarea placeholder="string to split" v-model="inputs.secret"></textarea>
    <button
      @click="
        $store
          .dispatch('secrets', {
            type: 'share',
            str: inputs.secret,
            shares: inputs.secretshares,
            thresh: inputs.secretthresh,
          })
          .then((d) => {
            $set(inputs, 'combined secrets', d);
          })
      "
    >
      Split Secret
    </button>
    <div>
      <input
        v-for="(inp, i) in inputs['combined secrets']"
        :key="inp + i"
        v-model="inputs.splitsecret[i]"
      />
      <button
        @click="
          $store
            .dispatch('secrets', {
              type: 'combine',
              shares: inputs.splitsecret,
            })
            .then((d) => {
              $set(inputs, 'shared secrets', d);
            })
        "
      >
        Combine
      </button>
    </div>
    <div v-if="Object.keys(inputs).length > 0">{{ inputs }}</div>

    <div class="container p4">
      <button
        type="button"
        @click="
          $store.dispatch('run', {
            fun: $store.state.app.advanced.functions.kok,
            payload: {
              url: 'https://us-central1-xmba-cloud-api.cloudfunctions.net/fundamerica/entities?type=GET',
              method: 'get',
              data: {},
            },
          })
        "
      >
        Func
      </button>
    </div>
    <div v-if="true">
      Hashes
      <input type="text" v-model="inputs.message" />
      <button
        @click="
          $store.dispatch('transact', {
            type: 'hashtable',
            contract: JSON.parse(inputs.message),
          })
        "
      >
        HASH ME OUT
      </button>
      <div>
        <h1>State Hashtable</h1>
        <code>{{
          JSON.stringify($store.state.app.advanced.hashtable, null, 4)
        }}</code>
        <h1>Lexicon Index</h1>
        <code>{{ $store.state.lexicon }}</code>
      </div>
    </div>

    
    <!-- <div class="fill-all container"><maps/></div> -->
    
    <!-- <comments commentsid="test" :key="$store.state.componentKeys.comments" />
    <reviews
      repid="tests"
      :key="'reviews' + $store.state.componentKeys.reviews"
    /> -->
    <!-- <input type="text" v-model="localsrc" placeholder="Appception Source">
    <iiframe :appsrc="localsrc"/> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      examples: [
        "https://api.nasa.gov/planetary/apod?api_key=NNKOjkoul8n1CH18TWA9gwngW1s1SmjESPjNoUFo",
        "https://us-central1-p3c-prsprty.cloudfunctions.net/test",
        "https://api.xmbl.org/price/",
        "https://api.xmbl.org/sponsor/",
      ],
      externalApi: {
        address: "",
        verb: "get",
      },
      jsond: true,
      test: "",
      data: "",
      inputs: { splitsecret: [] },
      local: false,
      localsrc: "",
      method: false,
      returnVal: false,
      save: false,
      show: {},
      state:{ if: {}},
      tokenType: "",
      txCreate: {
        to: "",
        address: "",
        amount: 0,
        fee: 0,
        sign: "",
      },
      variable: {
        type: "",
        key: "",
      },
      verbs: ["get", "post", "put", "delete"],
    };
  },
  methods: {
    decode() {
      const dw = require("web-digital-watermarking");
      const srcImageUrl =
        "https://ipfs.io/ipfs/QmWd91Jkj4MyfybfvmHXNdQmQNWaVJxJTBYxSoZV2AjJ7N";
      var img = new Image(),
        canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d"),
        src = srcImageUrl; // insert image url here
      console.log({src, ctx});
      // Notice that they set the cros\s origin attribute here
      img.crossOrigin = "Anonymous";
      async function run() {
        const deCodeImageUrl = await dw.getTextFormImageUrl(srcImageUrl).then(x=>x);
        console.log({ deCodeImageUrl });
        const deCodeImageElement = document.createElement("img");
        deCodeImageElement.src = deCodeImageUrl;
        document.body.appendChild(deCodeImageElement);
      }
      run();
    },
    testAction() {
      return this.$store.dispatch(this.test, this.data).then((data) => {
        return this.$set(this, "returnVal", data);
        // return this.returnVal = data
      });
    },
    testMutation() {
      return this.$store.commit(this.test, this.data);
    },
    testMethod() {
      return this.$store
        .dispatch("api", {
          address: this.externalApi.address,
          verb: this.externalApi.verb,
          data: this.data ? JSON.parse(this.data) : {},
          local: this.local,
        })
        .then((data) => {
          return this.$set(this, "returnVal", data);
        });
    },
  },
  name: "test",
};
</script>